export default __webpack_public_path__ + "static/media/Harness of the Stormbringer.27bff533.jpg";